import Component from './Component';
import 'bigtext/dist/bigtext.js';
import FontFaceObserver from 'fontfaceobserver';

// Floating content has Overlay text on desktop. It scales the text to the view width.

export default class Overlay extends Component {
  load() {
    this.initBigText();

    super.load();
  }

  initBigText() {

    const fontName = 'SouthAUS';

    new FontFaceObserver(fontName).load().then(() => {
      // The 'intro' font is specific to SA websites.
      console.log('fontFaceObserver load');
      $(window).on('resize', window.requestAnimationFrame.bind(window, () => {
        $('.overlay__text').bigtext({ limitingDimension: 'width' });
      })).trigger('resize');

      this.doEvents('font-loaded');
    }, () => {
      console.warn(fontName + ' is not available')
    });
  }
}
